module.exports = __webpack_public_path__ + "img/kb.1e120761.png";